import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules, RouteReuseStrategy } from '@angular/router';
import { provideTablerIcons } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import ApPreset from '../appreset';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { MessageService,ConfirmationService } from 'primeng/api';
import { CustomRouteReuseStrategy } from './core/strategies/route-reuse.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    
      provideHttpClient(withFetch()),
    
    provideTablerIcons(TablerIcons),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),

    providePrimeNG({
      ripple: true,
      theme: {
        preset: ApPreset,
        options: {
          darkModeSelector : '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'app-styles, primeng, another-css-library',
          },
        },
      },
    }),
    MessageService,
    ConfirmationService
  ],
};

